import * as THREE from 'three'

export function setupLights(scene, gui) {
    // Ambient light
    const ambientLight = new THREE.AmbientLight('#ffffff', 0.9)
    scene.add(ambientLight)

    // Ambient helper (visual indicator)
    const ambientHelper = new THREE.Mesh(
        new THREE.SphereGeometry(0.04, 8, 8),
        new THREE.MeshBasicMaterial({ color: ambientLight.color.clone().multiplyScalar(ambientLight.intensity) })
    )
    // ambient helper
    // ambientHelper.position.set(-1.2, 2.2, 0.5)
    // scene.add(ambientHelper)

    // Directional light
    const directionalLight = new THREE.DirectionalLight('#ffffff', 0.4)
    directionalLight.position.set(3, 6.3, 5.3)
    directionalLight.castShadow = true
    directionalLight.shadow.camera.near = 0.5
    directionalLight.shadow.camera.far = 20
    directionalLight.shadow.camera.left = -10
    directionalLight.shadow.camera.right = 10
    directionalLight.shadow.camera.top = 10
    directionalLight.shadow.camera.bottom = -10
    directionalLight.shadow.mapSize.width= 1000
    directionalLight.shadow.mapSize.height= 1000
    scene.add(directionalLight)

    // Directional light2
    const directionalLight2 = new THREE.DirectionalLight('#ffffff', 6)
    directionalLight2.position.set(-2.68, 4.59, -9.67)
    directionalLight2.castShadow = true
    directionalLight2.shadow.camera.near = 0.5
    directionalLight2.shadow.camera.far = 20
    directionalLight2.shadow.camera.left = -25
    directionalLight2.shadow.camera.right = 25
    directionalLight2.shadow.camera.top = 25
    directionalLight2.shadow.mapSize.width= 4000
    directionalLight2.shadow.mapSize.height= 4000
    directionalLight2.shadow.camera.bottom = -25
    scene.add(directionalLight2)

    // Helpers
    // const dirLightHelper = new THREE.DirectionalLightHelper(directionalLight, 0.5)
    // scene.add(dirLightHelper)

    // const dirLightCameraHelper = new THREE.CameraHelper(directionalLight.shadow.camera)
    // dirLightCameraHelper.visible = false
    // scene.add(dirLightCameraHelper)

    //Direct Lighting Helper Sphere
    const lightSphere = new THREE.Mesh(
        new THREE.SphereGeometry(0.05, 8, 8),
        new THREE.MeshBasicMaterial({ color: 0xffffff })
    )
    lightSphere.position.copy(directionalLight.position)
    scene.add(lightSphere)

    //Direct Lighting Helper Sphere
    const lightSphere2 = new THREE.Mesh(
        new THREE.SphereGeometry(0.05, 8, 8),
        new THREE.MeshBasicMaterial({ color: 0xffffff })
    )
    lightSphere2.position.copy(directionalLight2.position)
    scene.add(lightSphere2)

    // GUI for directional light
    const lightFolder = gui.addFolder('Directional Light')
    lightFolder.add(directionalLight.position, 'x', -10, 10, 0.01).name('posX')
    lightFolder.add(directionalLight.position, 'y', -10, 10, 0.01).name('posY')
    lightFolder.add(directionalLight.position, 'z', -10, 10, 0.01).name('posZ')
    // lightFolder.add({ helper: true }, 'helper').name('Show Helper').onChange(v => dirLightHelper.visible = v)
    // lightFolder.add({ camera: false }, 'camera').name('Show Shadow Camera').onChange(v => dirLightCameraHelper.visible = v)
    lightFolder.open()

    // GUI for directional light
    const lightFolder2 = gui.addFolder('Directional Light 2')
    lightFolder2.add(directionalLight2.position, 'x', -10, 10, 0.01).name('posX')
    lightFolder2.add(directionalLight2.position, 'y', -10, 10, 0.01).name('posY')
    lightFolder2.add(directionalLight2.position, 'z', -50, 10, 0.01).name('posZ')
    lightFolder2.open()

    // GUI for ambient light
    const ambientFolder = gui.addFolder('Ambient Light')
    const colorProxy = { color: '#ffffff' }
    ambientFolder.addColor(colorProxy, 'color').name('color').onChange((val) => {
        ambientLight.color.set(val)
        ambientHelper.material.color.copy(ambientLight.color).multiplyScalar(ambientLight.intensity)
    })
    ambientFolder.add(ambientLight, 'intensity', 0, 2, 0.01).name('intensity').onChange(() => {
        ambientHelper.material.color.copy(ambientLight.color).multiplyScalar(ambientLight.intensity)
    })
    ambientFolder.add({ showHelper: true }, 'showHelper').name('Show Helper').onChange(v => ambientHelper.visible = v)
    ambientFolder.open()

    // Fire Point Light
    const fireLight = new THREE.PointLight(0xff7700, 2.0, 3.0)
    fireLight.position.set(-3.5, 0.5, -2.4) // Adjust position based on your fire location
    scene.add(fireLight)
    

    // enable shadows for fire light
    fireLight.castShadow = true
    fireLight.shadow.mapSize.width = 1024
    fireLight.shadow.mapSize.height = 1024
    fireLight.shadow.bias = -0.001
    fireLight.shadow.radius = 2

    // Fire light helper
    const fireLightHelper = new THREE.PointLightHelper(fireLight, 0.1)
    scene.add(fireLightHelper)
    fireLightHelper.visible = false
    // GUI for fire light
    const fireLightFolder = gui.addFolder('Fire Light')
    fireLightFolder.addColor({ color: 0xff7700 }, 'color')
        .name('Light Color')
        .onChange(value => fireLight.color.set(value))
    fireLightFolder.add(fireLight, 'intensity', 0, 10, 0.1).name('Intensity')
    fireLightFolder.add(fireLight, 'distance', 0, 10, 0.1).name('Distance')
    fireLightFolder.add(fireLight, 'castShadow').name('Cast Shadow').onChange(v => {
        fireLight.castShadow = v
    })

    // mapSize choice
    const mapSizeProxy = { mapSize: 1024 }
    fireLightFolder.add(mapSizeProxy, 'mapSize', [512, 1024, 2048]).name('Shadow MapSize').onChange((v) => {
        fireLight.shadow.mapSize.width = v
        fireLight.shadow.mapSize.height = v
        // must mark shadow map for update
        fireLight.shadow.map = null
    })
    fireLightFolder.add(fireLight.shadow, 'bias', -0.01, 0.01, 0.0001).name('Shadow Bias')
    fireLightFolder.add(fireLight.shadow, 'radius', 0, 8, 0.1).name('Shadow Radius')

    fireLightFolder.add(fireLight.position, 'x', -5, 5, 0.1).name('Position X')
    fireLightFolder.add(fireLight.position, 'y', -5, 5, 0.1).name('Position Y')
    fireLightFolder.add(fireLight.position, 'z', -5, 5, 0.1).name('Position Z')
    fireLightFolder.add({ helper: false }, 'helper')
        .name('Show Helper')
        .onChange(value => fireLightHelper.visible = value)
    fireLightFolder.open()

    return {
        ambientLight,
        ambientHelper,
        directionalLight,
        directionalLight2,
        // dirLightHelper,
        // dirLightCameraHelper,
        lightSphere,
        lightSphere2,
        fireLight,
        fireLightHelper,
    }
}